import PropTypes from 'prop-types';
import React from 'react';

const TruckFilled = ({ size, color }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1875 6.875H11.875V4.76367C11.875 4.51562 11.7754 4.27734 11.5996 4.10156L9.64844 2.15039C9.47265 1.97461 9.23437 1.875 8.98633 1.875H8.125V0.9375C8.125 0.419922 7.70508 0 7.1875 0H0.9375C0.419922 0 0 0.419922 0 0.9375V7.1875C0 7.70508 0.419922 8.125 0.9375 8.125H1.25C1.25 9.16016 2.08984 10 3.125 10C4.16016 10 5 9.16016 5 8.125H7.5C7.5 9.16016 8.33984 10 9.375 10C10.4102 10 11.25 9.16016 11.25 8.125H12.1875C12.3594 8.125 12.5 7.98438 12.5 7.8125V7.1875C12.5 7.01562 12.3594 6.875 12.1875 6.875ZM3.125 9.0625C2.60742 9.0625 2.1875 8.64258 2.1875 8.125C2.1875 7.60742 2.60742 7.1875 3.125 7.1875C3.64258 7.1875 4.0625 7.60742 4.0625 8.125C4.0625 8.64258 3.64258 9.0625 3.125 9.0625ZM9.375 9.0625C8.85742 9.0625 8.4375 8.64258 8.4375 8.125C8.4375 7.60742 8.85742 7.1875 9.375 7.1875C9.89258 7.1875 10.3125 7.60742 10.3125 8.125C10.3125 8.64258 9.89258 9.0625 9.375 9.0625ZM10.9375 5H8.125V2.8125H8.98633L10.9375 4.76367V5Z"
      fill={color}
    />
  </svg>
);

TruckFilled.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

TruckFilled.defaultProps = {
  size: 13,
  color: '#676A6C',
};

export default TruckFilled;
